import gql from 'graphql-tag'

export const GET_DRIVERS = gql`
query Drivers($filter: GetDriversInput) {
  drivers(filter: $filter) {
    drivers {
      data {
        company {
          id
          name
        }
        userId
        fullname
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
      }
    }
  }
}
`
